var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLgiSicht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lgi_x5F_sicht",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "68px",
    viewBox: "0 0 48 68",
    style: {
      enableBackground: "new 0 0 48 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#B33229;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.3,46H8.7c-1.3,0-2.3,1.1-2.3,2.3V63c0,1.3,1.1,2.4,2.3,2.4h30.6c1.3,0,2.3-1.1,2.3-2.4V48.3 C41.6,47.1,40.6,46,39.3,46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.3,46.6H8.7c-1,0-1.8,0.8-1.8,1.8V63c0,1,0.8,1.8,1.8,1.8h30.6c1,0,1.8-0.8,1.8-1.8V48.3C41,47.4,40.3,46.6,39.3,46.6 z M40.2,63c0,0.5-0.4,0.9-0.9,0.9H8.7c-0.5,0-0.9-0.4-0.9-0.9V48.3c0-0.5,0.4-0.9,0.9-0.9h30.6c0.5,0,0.9,0.4,0.9,0.9V63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.3,65.5H8.7c-1.3,0-2.4-1.1-2.4-2.4V48.3c0-1.3,1.1-2.4,2.4-2.4h30.6c1.3,0,2.4,1.1,2.4,2.4V63 C41.7,64.4,40.6,65.5,39.3,65.5z M8.7,46.1c-1.2,0-2.3,1-2.3,2.3V63c0,1.2,1,2.3,2.3,2.3h30.6c1.2,0,2.3-1,2.3-2.3V48.3 c0-1.2-1-2.3-2.3-2.3C39.3,46.1,8.7,46.1,8.7,46.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,4.5c-1.1,0-2.1,0.6-2.6,1.5L2.8,38.5c-0.5,0.9-0.5,2.1,0,3C3.4,42.4,4.4,43,5.4,43h37.1 c1.1,0,2.1-0.6,2.6-1.5s0.5-2.1,0-3L26.6,6C26.1,5.1,25.1,4.5,24,4.5L24,4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,9.5L40.8,39H7.2L24,9.5 M24,5.5c-0.7,0-1.4,0.3-1.7,1L3.7,39c-0.8,1.3,0.2,3,1.7,3h37.1 c1.5,0,2.5-1.7,1.7-3L25.7,6.5C25.4,5.9,24.7,5.5,24,5.5L24,5.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "road"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 57.9,
    width: 27,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "road_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 54.7,
    width: 27,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "road_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 51.4,
    width: 27,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 33,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "25,31 23,31 22,17 26,17  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLgiSicht);
export default __webpack_public_path__ + "static/media/icon-lgi_sicht.a80fa7bc49032004faf2373943ef8ff4.svg";
export { ForwardRef as ReactComponent };